'use strict';

define(['utils/underscore', 'utils/helpers', 'parsers/captions/srt'], function (_, utils, srt) {

    function Thumbnail(obj) {
        this.begin = obj.begin;
        this.end = obj.end;
        this.img = obj.text;
    }

    var ThumbnailsMixin = {
        loadThumbnails: function loadThumbnails(file) {
            if (!file) {
                return;
            }
            this.vttPath = file.split('?')[0].split('/').slice(0, -1).join('/');
            // Only load the first individual image file so we can get its dimensions. All others are loaded when
            // they're set as background-images.
            this.individualImage = null;
            utils.ajax(file, this.thumbnailsLoaded.bind(this), this.thumbnailsFailed.bind(this), {
                plainText: true
            });
        },

        thumbnailsLoaded: function thumbnailsLoaded(evt) {
            var data = srt(evt.responseText);
            if (_.isArray(data)) {
                _.each(data, function (obj) {
                    this.thumbnails.push(new Thumbnail(obj));
                }, this);
                this.drawCues();
            }
        },

        thumbnailsFailed: function thumbnailsFailed() {},

        addThumbnail: function addThumbnail(obj) {
            this.thumbnails.push(new Thumbnail(obj));
        },

        chooseThumbnail: function chooseThumbnail(seconds) {
            // 如果不在时间段范围内，url则返回空 zhangzhe 2017-04-24
            if (!_.find(this.thumbnails, function (thumbnail) {
                return thumbnail.begin <= seconds && thumbnail.end >= seconds;
            })) {
                return '';
            }

            var idx = _.sortedIndex(this.thumbnails, { end: seconds }, _.property('end'));
            if (idx >= this.thumbnails.length) {
                idx = this.thumbnails.length - 1;
            }
            var url = this.thumbnails[idx].img;
            if (url.indexOf('://') < 0) {
                url = this.vttPath ? this.vttPath + '/' + url : url;
            }

            return url;
        },

        loadThumbnail: function loadThumbnail(seconds) {
            var url = this.chooseThumbnail(seconds);
            var style = {
                display: 'block',
                margin: '0 auto',
                backgroundPosition: '0 0',
                backgroundRepeat: 'no-repeat'
            };

            var hashIndex = url.indexOf('#xywh');
            if (hashIndex > 0) {
                try {
                    var matched = /(.+)\#xywh=(\d+),(\d+),(\d+),(\d+)/.exec(url);
                    url = matched[1];
                    style.backgroundPosition = matched[2] * -1 + 'px ' + matched[3] * -1 + 'px';
                    style.width = matched[4];
                    style.height = matched[5];
                } catch (e) {
                    //this.vttFailed('Could not parse thumbnail');
                    return;
                }
            } else if (url) {
                if (!this.individualImage) {
                    this.individualImage = new Image();
                    this.individualImage.onload = _.bind(function () {
                        this.individualImage.onload = null;
                        this.timeTip.image({ width: this.individualImage.width, height: this.individualImage.height });
                    }, this);
                    this.individualImage.src = url;
                } else {
                    style.width = this.individualImage.width;
                    style.height = this.individualImage.height;
                }
            }

            if (url === '') {
                style.width = 0;
                style.height = 0;
            }

            style.backgroundImage = 'url("' + url + '")';

            return style;
        },

        showThumbnail: function showThumbnail(seconds) {
            if (this.thumbnails.length < 1) {
                return;
            }
            this.timeTip.image(this.loadThumbnail(seconds));
        },

        resetThumbnails: function resetThumbnails() {
            this.timeTip.image({
                backgroundImage: '',
                width: 0,
                height: 0
            });
            this.thumbnails = [];
        }
    };

    return ThumbnailsMixin;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/view/components/thumbnails.mixin.js
 ** module id = 192
 ** module chunks = 0
 **/